// Global Components
import * as React from 'react';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  className?: string;
  onChange?: (value: null | string) => unknown;
  required?: boolean;
  value?: null | string;
};

export type $Props = $InputProps & $OptionalProps & {
  highlight: boolean;
  labelFalse: string;
  labelTrue: string;
  name: string;
};

type $State = {
  value: null | string;
};

class InputYesNoView extends React.Component<$Props, $State> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    onChange: undefined,
    required: undefined,
    value: undefined,
  };

  renderValue({
    label,
    type,
  }: {
    label: string;
    type: string;
  }) {
    const {
      highlight,
      isValid,
      name,
      onChange,
      required,
      setValue,
      value,
    } = this.props;

    const id = `${name}${type}`;
    const invalid: boolean = highlight && !isValid;

    return (
      <>
        <input
          checked={value === type}
          className={`border-${invalid ? 'red-600' : 'gray-400'} w-6 h-6 text-blue-900 bg-gray-100 rounded focus:ring-blue-900 focus:ring-2`}
          id={id}
          name={name}
          onChange={() => {
            setValue(type);

            if (onChange) {
              onChange(type);
            }
          }}
          required={required}
          type={'radio'}
          value={type}
        />
        <label
          className={`ml-2 text-sm font-medium text-${invalid ? 'red-600' : 'gray-900'} mr-2`}
          htmlFor={id}
        >
          {label}
        </label>
      </>
    );
  }

  render() {
    const {
      className,
      labelFalse,
      labelTrue,
    } = this.props;

    return (
      <div className={`InputYesNo flex items-center ${className || ''}`}>
        {this.renderValue({
          label: labelTrue,
          type: 'true',
        })}
        {this.renderValue({
          label: labelFalse,
          type: 'false',
        })}
      </div>
    );
  }
}

export default InputYesNoView;
